import { useAppSelector } from "@store";
import { getSelectedSetting } from "@store/story/selectors";

type WatermarkType = {
  active: boolean;
  content: string;
  opacity: number;
  color: string;
};

export const useGetWatermark = () => {
  return useAppSelector(getSelectedSetting<WatermarkType>("watermark"));
};
